import Styles from './ModuleView.module.scss';

export function ModuleView({ data }) {
  return (
    <div className={Styles.mainContainer} style={{ justifyContent: !data?.icon && 'center' }}>
      <p className={Styles.title}>
        {data?.title}
      </p>
      {data?.icon && <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data?.icon}`} alt="new module icon" />}
    </div>
  )
}
